<template>
	<div class="p2 bg4 b1 bc7 r2 fs3 cu2" @click.stop="$emit('selected', node)">
		<div class="lh125 c1 fw7">
			{{ node.name }}
			<j-tag v-if="node.isOptional" :label="$t('optional')" size="xsmall" />
		</div>
		<div class="lh125" v-if="node.formattedValue">
			{{ node.formattedValue }}
		</div>
		<!-- If we don't have formattedValue, reach to value and show scalarValue -->
		<div class="lh125" v-else>{{ node.value | parseScalarValue }}</div>
		<!-- Text see/hide children -->
		<div
			v-if="hasChildren && !isExpanded"
			@click="isExpanded = true"
			class="c2 fs3 fw7 lh125 mt1"
		>
			{{ $t("see_sub_benefits") }}
		</div>
		<div
			v-if="hasChildren && isExpanded"
			@click="isExpanded = false"
			class="c2 fs3 fw7 lh125 mt1"
		>
			{{ $t("hide_sub_benefits") }}
		</div>
		<!-- children -->
		<template v-if="hasChildren && isExpanded">
			<benefit-tree-node
				v-for="(item, i) in node.children"
				:key="i"
				:node="item"
				@selected="handleSelect"
				class="mt2"
			/>
		</template>
	</div>
</template>

<script>
import JTag from "@/components/JTag"
export default {
	components: { JTag },
	name: "BenefitTreeNode",
	props: { node: { type: Object } },
	data() {
		return {
			isExpanded: false
		}
	},
	computed: {
		hasChildren() {
			return this.node.children && this.node.children.length
		}
	},

	methods: {
		handleSelect(event) {
			this.$emit("selected", event)
		}
	},

	filters: {
		parseScalarValue(val) {
			if (!val) return null
			if (val.numberValue !== null) return val.numberValue
			if (val.stringValue !== null) return val.stringValue
			if (val.dateValue !== null) return val.dateValue
			if (val.booleanValue !== null) return val.booleanValue
			return null
		}
	}
}
</script>
